import {Component, OnInit, ViewChild} from '@angular/core';
import {AcabimDonutChartComponent} from '@cas-hub/acabim-common-client/lib/containers/acabim-donut-chart/acabim-donut-chart.component';
import {AdminDashboardApiService} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-site-related-stats',
    templateUrl: './site-related-stats.component.html',
    styleUrls: ['./site-related-stats.component.scss']
})
export class SiteRelatedStatsComponent implements OnInit {
    @ViewChild('chart') chart!: AcabimDonutChartComponent;
    isLoading = false;
    mockData: any = {
        sites: {
            count: 0,
            projects: []
        }
    };
    labels: string[] = [];
    colors: string[] = [];
    data: number[] = [];

    dataSource = {};
    DEFAULT_COLORS = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099',
        '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E',
        '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC',
        '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];

    constructor(private readonly adminDashboardService: AdminDashboardApiService) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        // tslint:disable-next-line:no-shadowed-variable
        this.adminDashboardService.getSiteProjectStats().subscribe(d => {
            this.mockData.sites.count = d.length;
            d.forEach(site => {
                const capIDs: { capsCount: number }[] = [];
                site.projects.forEach(project => {
                    capIDs.push({capsCount: project.capId.length});
                });
                this.mockData.sites.projects.push({projectCount: site.projects.length, caps: capIDs});
            });
            const labels = [];
            const data = [];
            const backgroundColor = [];
            if (this.chart) {
                this.chart.chart.reinit();
            }
            for (let i = 0; i < this.mockData.sites.count; i++) {
                // tslint:disable-next-line:prefer-for-of
                for (let j = 0; j < this.mockData.sites.projects[i].projectCount; j++) {
                    const labelString = 'p' + (j + 1) + ':' + this.mockData.sites.projects[i].caps[j].capsCount;
                    data.push(this.mockData.sites.projects[i].projectCount);
                    labels.push(labelString);
                    backgroundColor.push(this.DEFAULT_COLORS[i]);
                }

            }
            this.labels = labels;
            this.colors = backgroundColor;
            this.data = data;
            this.isLoading = false;
            this.dataSource = {
                labels: this.labels,
                datasets: [
                    {
                        backgroundColor: this.colors,
                        data: this.data
                    },
                ]
            };
            if (this.chart) {
                this.chart.chart.reinit();
                this.chart.chart.refresh();

            }

        });
    }

}
